<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 银行支付场景:说明信息卡片
 * @Date: 2021-09-09 09:43:23
 * @LastEditTime: 2021-09-28 10:31:40
-->
<template>
  <div class="bank-form-content">
    <p>Add funds by <b>Wire bank transfer</b></p>
    <p>
      We accept Wire bank payments only in manual mode. <br>
      To top-up your balance with Wire transfer please contact support for invoice and
      transaction details.
    </p>
    <p style="color: #F99945">
      Please note, minimum payment amount for this payment method is <b>$1000.</b>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Bank'
}
</script>

<style scoped>
.bank-form-content {
  color: #1e183f;
  max-width: 935px;
  padding: 10px 15px;
  background: #FCFCFF;
  border: 1px solid #E4E7ED;
  border-radius: 3px;
}
</style>
